<!-- /*
 * @Author: sunxh
 * @Date: 2022-07-28 17:49:16
 * @Description: 
 * @indicator: 是否显示自定义指示器
 * @direction:方向，默认是水平方向'horizontal' | 'vertical'
   @defaultIndex:初始位置,默认值为1，因为循环所以在头部和尾部添加了图片
   @autoplay：自动播放 默认false
   @interval: 自动播放间隔
   @items:数据结构要求是：[
        {
            image: "0b9dea72a4a8c47b6b04222d021e0c2060814bf1b",
            target: {
                title: "小米老人意外险2021版",
                url: "https://api.miinsurtech.com/insurance/frame.html?source=p0&from=mifi_ins_banner_3#/detail/4369866882128678912?_k=q07b1o",
            },
            stat: "ins_ins_item_banner_1",
        }]
 */ -->
<script>
    import { touchAction } from "../../utils/dragMove";
    //传递props
    export let indicator = false;
    export let direction = "horizontal";
    export let defaultIndex = 0;
    export let autoplay = false;
    export let interval = 3000;
    export let items = [];
    //生命变量
    const clsPrefix = "sui-carousel";
    let indicatorIndex = 0;
    let len = items.length;
    $: {
        len = items.length;
    }
    function handleClick({ target, stat }) {
        console.log(target, stat);
    }
    function handleEnd(e) {
        indicatorIndex = e.detail.index - 1;
    }
    let ih = 0;
</script>

{#if items && items.length > 1}
    <div
        class={`${clsPrefix} ${$$props.class || ""}`}
        aria-roledescription="carousel"
    >
        <div
            aria-live={autoplay ? "off" : "polite"}
            class={`${clsPrefix}-inner`}
            class:vertical={direction === "vertical"}
            use:touchAction={{ defaultIndex:defaultIndex+1, direction, autoplay, interval }}
            on:dragend={handleEnd}
            style:height={`${ih}px`}
        >
            {#each items as { image, target, stat }, i}
                <div
                    role="group"
                    bind:clientHeight={ih}
                    aria-roledescription="slide"
                    aria-label={`${i + 1} of ${len}`}
                    class={`${clsPrefix}-item`}
                    class:vertical={direction === "vertical"}
                    on:click={() => handleClick({ target, stat })}
                >
                    <img src={image} alt="" />
                </div>
            {/each}
        </div>
        {#if indicator}
            <div
                class={`${clsPrefix}-indicator`}
                class:vertical={direction === "vertical"}
            >
                {#each items as item, i}
                    <b data-id={i} class:active={indicatorIndex === i} />
                {/each}
            </div>
        {/if}
    </div>
{:else if items && items.length > 0}
    <div class={`${clsPrefix} ${$$props.class || ""}`}>
        <div class={`${clsPrefix}-inner`}>
            {#each items as { image, target, stat }, i}
                <div
                    class={`${clsPrefix}-item`}
                    on:click={() => handleClick({ target, stat })}
                >
                    <img src={image} alt="" />
                </div>
            {/each}
        </div>
    </div>
{/if}

<style lang="less">
    @import "./carousel.less";
</style>
